import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

export const putNewUserContactInfoOTP = async (otp = '', service_id = '') => {
  const { token, userID } = useCurrentUser();
  const apiURL = `${API_HOST}/users/${userID}/update_contact_info`;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'x-dqpn-user-id': userID,
  };

  const body = {
    user: {
      otp: otp,
      service_id: service_id,
    },
  };

  try {
    const response = await axios.put(apiURL, body, { headers });
    return response.data; // Assuming you want to return the response data
  } catch (error) {
    console.error('Exception occurred while updating contact info:', error.message);
    if (
      error.response.data.message === 'Phone number already exists' ||
      error.response.data.message === 'Email already exists'
    ) {
      return { statusCode: 422 };
    }
    return null;
  }
};
